import React, { useState } from "react";
import "../../../assests/css/admin/AdmincmsManagement/AdmincmsNavbar.css";
import { Link, useLocation } from "react-router-dom";

const navLinks = [
  { label: "Home", href: "/Admin/Home/cms" },
  // { label: "About Us", href: "#about" },
  // { label: "Contact", href: "#contact" },
  { label: "Event", href: "/Admin/Event/cms" },
  // { label: "Principal", href: "/Admin/Principal/cms" },
];

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const toggleMenu = () => {
    setIsOpen((prev) => !prev);
  };

  const handleLinkClick = () => {
    setIsOpen(false);
  };

  const isActive = (href) => {
    if (href.startsWith("#")) {
      return false;
    }

    return location.pathname === href;
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <a href="#home" className="navbar-logo">
          <span>GGCW</span>
        </a>

        <button
          className="navbar-toggle"
          onClick={toggleMenu}
          aria-label="Toggle Navigation"
        >
          <span className={isOpen ? "bar bar-1 open" : "bar bar-1"}></span>
          <span className={isOpen ? "bar bar-2 open" : "bar bar-2"}></span>
          <span className={isOpen ? "bar bar-3 open" : "bar bar-3"}></span>
        </button>

        <ul className={isOpen ? "navbar-links open" : "navbar-links"}>
          {navLinks.map((link) => {
            const active = isActive(link.href);

            // React Router Links
            if (link.href.startsWith("/")) {
              return (
                <li key={link.label}>
                  <Link
                    to={link.href}
                    className={active ? "active" : ""}
                    onClick={handleLinkClick}
                  >
                    {link.label}
                  </Link>
                </li>
              );
            }

            // Hash Links
            return (
              <li key={link.label}>
                <a
                  href={link.href}
                  className={active ? "active" : ""}
                  onClick={handleLinkClick}
                >
                  {link.label}
                </a>
              </li>
            );
          })}
        </ul>
      </div>
    </nav>
  );
}

export default Navbar;